@if (person) {
    <div class="mention-person d-flex gap-1 align-items-center">
        <adapt-person-image [person]="person"
                            imageSize="sm"></adapt-person-image>
        <span>{{ person.fullName }}</span>
    </div>
} @else {
    <p>Loading</p>
}
